export default __webpack_public_path__ + "static/media/bitget.5c07742d.png";